<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('menus') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <router-link to="/system/menu" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
        </div>
        <div class="x_body">
            <div class="card f_card no-bor">
                <div class="card-header">
                    <div class="card-item upper">{{ $t('menus') }}</div>
                </div>
                <div class="card-body p-0">
                    <table class="table no-bor">
                        <thead>
                            <tr>
                                <th>{{ $t('code') }}</th>
                                <th>{{ $t('name') }}</th>
                                <th>{{ $t('link') }}</th>
                                <th class="text-center">{{ $t('icon') }}</th> 
                                <th class="text-center">{{ $t('sort') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td>{{ret.Code}}</td>
                                <td><router-link :to="{ name: 'menu_update', params: { id: ret.Id } }">{{ret.Name}}</router-link></td>
                                <td>{{ret.Link}}</td>
                                <td class="text-center"><i :class="ret.Icon" aria-hidden="true"></i></td>
                                <td class="text-center">{{ret.Sort}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            records: []
        }
    },
    created(){
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            this.$api().post('system/menus', {}).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Json.Menus;
                }
            }).finally(function() { loading.hide(); });
        }
    }
}
</script>